import { useRouter } from 'next/router';

import { isShowShoppingCart } from '@r1-frontend/entities/Layout/Header/isShowShoppingCart';
import { breakpoints } from '@r1-frontend/entities/Layout/Header/types';

import { CartStroke } from '@r1-frontend/ui-kit/atoms/svg/shop';
import { Text } from '@r1-frontend/ui-kit/atoms/typography/text';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { MenuButton } from './MenuButton';

export const CartButton = () => {
    const router = useRouter();
    const isSmallMobile = useMatchMediaByWidth(breakpoints.mMobile);
    const showShoppingCart = isShowShoppingCart();

    if (!showShoppingCart) {
        return null;
    }

    const handleClick = () => {
        router.push('/cart');
    };

    return (
        <MenuButton onClick={handleClick} data-test='cart-link'>
            <CartStroke size={isSmallMobile ? 24 : 20}/>
            {!isSmallMobile && (
                <Text $color={'head'} $size={'md'} $weight={'medium'}>Корзина</Text>
            )}
        </MenuButton>
    );
};
